import { Component, OnDestroy, ElementRef, Input, ChangeDetectorRef } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { FormBuilder, FormsModule } from '@angular/forms';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { DxDataGridModule, DxLookupModule } from 'devextreme-angular';
import { AsValidatorDirective } from '@asamco/base';
import { showErrorSwal } from '@asamco/utils';
import { SimpleLinkService } from '../../interfaces/simple-link-service.interface';
import { MappedService } from '../../interfaces/mapped-service.interface';
import { ServicePricingModel } from '../../interfaces/service-pricing-model.interface';

@Component({
    templateUrl: './service-catalog-prices-modal.component.html',
    selector: 'service-catalog-prices-modal',
    styleUrls: ['../../../../../../application-link/shared/src/lib/styles/csp-styles.scss', 'service-catalog-prices-modal.component.scss'],
    standalone: true,
    imports: [
        NgIf,
		NgFor,
		FormsModule,
        DxDataGridModule,
		DxLookupModule,
        AsyncPipe,
		AsValidatorDirective
    ],
})
export class ServiceCatalogPricesModalComponent implements OnDestroy {
	destroy$ = new Subject<void>();

	@Input()
	ls: SimpleLinkService;

	@Input()
	linkID: string;

	visible$ = new BehaviorSubject<boolean>(false);

	updating = false;

	mappedServices: MappedService[];

	externalServices: ServicePricingModel[];

	costMode: boolean;

	constructor(public el: ElementRef, public fb: FormBuilder, private cdRef: ChangeDetectorRef) {
		//
	}

	ngOnInit() {

	}

	show(mappedServices: MappedService[], costMode: boolean) {
		this.costMode = costMode;
		this.mappedServices = mappedServices;
		for(const service of this.mappedServices) {
			var foundExternalService = this.externalServices.find(s => s.code === service.targetServiceCode);
			service.targetPrice = foundExternalService?.unitPrice;
		}

		this.visible$.next(true);
	}

	exit(): void {
		this.visible$.next(false);
	}

	onCellPrepared(e: any) {
		const ce = e.cellElement;
		if (e.rowType === 'header') {
			if (ce.lastChild?.style) {
				ce.lastChild.style.whiteSpace = 'normal';
				ce.lastChild.style.textOverflow = 'clip';
				ce.lastChild.style.overflow = 'visible';
			}
		}
	}

	onPostClicked($event, catalogPriceLine) {
		const foundIndex = this.externalServices.findIndex(s => s.code === catalogPriceLine.targetServiceCode);

		this.updating = true;
		catalogPriceLine.updating = true;

		this.ls.target.UpdateCatalogPrice({
			serviceId: this.externalServices[foundIndex].id,
			updatedPrice: catalogPriceLine.price,
			costMode: this.costMode
		}).subscribe({
			next: updatedService => {
				this.updating = false;
				catalogPriceLine.updating = false;
				this.externalServices.splice(foundIndex, 1, updatedService);
				catalogPriceLine.targetPrice = this.costMode ? updatedService.unitCost : updatedService.unitPrice;
				this.cdRef.detectChanges();
			},
			error: err => {
				this.updating = false;
				catalogPriceLine.updating = false;
				showErrorSwal(err);
			}
		});
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
